import { useState, useEffect, useContext } from "react";

import axios from "axios";

import UserService from "../../services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import {getChartList} from "../../services/ConfigServices";

export default function UseChartsListCall(cardChartsList) {
  const [chartsList, setChartsList] = useState([{ name: String, id: Number, version: String }]);
  const [selectedCharts, setSelectedCharts] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  useEffect(() => {
    axios
      .get(
        getChartList(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setChartsList(res.data);
      });
  }, []);

  useEffect(() => {
    if (cardChartsList !== undefined) {
      let chartsCardId = [];
      for (let i = 0; i < cardChartsList.length; i++) {
        chartsCardId.push(Number(cardChartsList[i].id));
      }
      let getChartNames = chartsList.filter((chartsList) =>
        chartsCardId.includes(chartsList.id)
      );
      setSelectedCharts(getChartNames);
    }
  }, [chartsList]);

  return { chartsList, selectedCharts, setSelectedCharts, setChartsList };
}
